import React from 'react';
import styled, { keyframes } from 'styled-components';

interface Props {
  size?: number;
}

function LoadingDot({ size }: Props) {
  return (
    <LoadingDots role="status" aria-label="로딩 중" $size={size}>
      <i />
      <i />
      <i />
    </LoadingDots>
  );
}

export default LoadingDot;

const pulse = keyframes`
  0%   { transform: scale(0.6); opacity: .35; }
  20%  { transform: scale(1);   opacity: 1;   }
  100% { transform: scale(0.6); opacity: .35; }
`;

const LoadingDots = styled.span<{ $size?: number }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 1em;
  line-height: 1;

  /* color가 지정되면 그걸, 아니면 currentColor를 사용 */
  color: inherit;

  & > i {
    height: ${({ $size }) => ($size ? `${$size}px` : '100% ')};
    aspect-ratio: 1;
    border-radius: 50%;
    background: currentColor;
    animation: ${pulse} 1.2s infinite ease-in-out;
  }

  /* 지연을 줘서 왼→가운데→오른쪽 순서로 튀게 */
  & > i:nth-child(2) {
    animation-delay: calc(1.2s / 6);
  }
  & > i:nth-child(3) {
    animation-delay: calc(1.2s / 3);
  }
`;
